import { Controller } from '@hotwired/stimulus'

export default class SubmitOnceController extends Controller<HTMLFormElement> {
  static targets = ['button']

  declare readonly buttonTarget: HTMLButtonElement
  declare readonly hasButtonTarget: boolean

  private readonly disableButton = (): void => this.setButtonDisabled(true)
  private readonly enableButtonOnRestore = (event: PageTransitionEvent): void => {
    if (event.persisted) {
      this.setButtonDisabled(false)
    }
  }

  connect (): void {
    this.element.addEventListener('submit', this.disableButton)
    window.addEventListener('pageshow', this.enableButtonOnRestore)
  }

  disconnect (): void {
    this.element.removeEventListener('submit', this.disableButton)
    window.removeEventListener('pageshow', this.enableButtonOnRestore)
  }

  private setButtonDisabled (disabled: boolean): void {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = disabled
    }
  }
}
